import Services from "../Services";

export default class RegistererProviderCallback {
    static $services = Services;

    static boot(callback, ...params) {
        RegistererProviderCallback.$services.providerCallbacks.boot.push({callback: callback, arguments: params})
    }

    static booting(callback, ...params) {
        RegistererProviderCallback.$services.providerCallbacks.booting.push({callback: callback, arguments: params})
    }

    static booted(callback, ...params) {
        RegistererProviderCallback.$services.providerCallbacks.booted.push({callback: callback, arguments: params})
    }
}